export default class PreviewLayer {
  constructor() {
    if (TMON.oApp.oUtil.isInternetExplorer()) {
      // 사용자가 IE를 사용하고 있다면
      this.sSwiperType = 'pcSwiper';
    } else {
      this.sSwiperType = 'swiperJS';
    }
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_previewLayer';
    this.realIndex = 0;
    this.sPagingType = TMON.oApp.sPlatform === 'PW' ? 'number' : 'dot';
  }

  /**
   * 레이어 열기 함수
   */
  open = (nIndex, aImageList) => {
    this.realIndex = nIndex;
    this.render(aImageList);
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }

    if (aImageList.length < 2) {
      $('[data-role=previewImageButton]').hide();
    }
    this.initSwiper();
    this.setEvent();
  };

  initSwiper() {
    this.destroySwiper();
    if ($('#_reviewImageSwiper').find('li').length < 2) {
      return;
    }
    if (this.sSwiperType === 'pcSwiper') {
      $('#sliderPreview img').addClass('blind');
      $('#sliderPreview').pcSlider({
        welBtnPrev: $('#_layerContainer [data-type=prev]'),
        welBtnNext: $('#_layerContainer [data-type=next]'),
        nView: 1,
        nSpeed: 300,
        nMarginRight: 0,
        afterSlide: htIndex => {
          this.realIndex = htIndex.current - 1;
          this.onChangeSlide();
        },
        initComplete: oSlide => {
          this.oSwipeByPcSlider = oSlide;
          $('#sliderPreview img').removeClass('blind');
        },
      });
      $('#sliderPreview').css('overflow-x', 'hidden'); // IE positon 정보에 맞게 보이지 않는 img hidden 처리
    } else {
      this.oSwipeBySwiperJS = new window.Swiper('#_reviewImageSwiper', {
        initialSlide: this.realIndex,
        pagination: '.paging',
        paginationClickable: true,
        paginationType: 'custom',
        autoplay: 0,
        autoplayDisableOnInteraction: true,
        loop: true,
      });
    }
  }

  destroySwiper() {
    if (this.oSwipeByPcSlider) {
      this.oSwipeByPcSlider = null;
      delete this.oSwipeByPcSlider;
    }
    if (this.oSwipeBySwiperJS) {
      this.oSwipeBySwiperJS.destroy();
      delete this.oSwipeBySwiperJS;
    }
  }

  setEvent() {
    if (this.oSwipeBySwiperJS) {
      this.oSwipeBySwiperJS.on('slideChange', () => {
        this.onChangeSlide();
      });
    }
    if (this.oSwipeBySwiperJS) {
      $('[data-role=previewImageButton]').on('click', e => {
        this.onClickSlide(e);
      });
    }
  }

  clearEvent() {
    this.destroySwiper();
  }

  onClickSlide = e => {
    const welTargetButton = $(e.currentTarget);
    if (welTargetButton.attr('data-type') === 'prev') {
      this.oSwipeBySwiperJS.slidePrev();
    } else {
      this.oSwipeBySwiperJS.slideNext();
    }
  };

  onChangeSlide = () => {
    if (this.oSwipeBySwiperJS) {
      this.realIndex = this.oSwipeBySwiperJS.realIndex;
    }
    if (this.sPagingType === 'dot') {
      $('#_imagePreviewPager button')
        .removeClass('on')
        .eq(this.realIndex)
        .addClass('on');
    } else if (this.sPagingType === 'number') {
      $('#_imagePreviewPager .current').html(this.realIndex + 1);
    }
  };

  render = aImageList => {
    $(`#${this.sWrapper}`).remove();
    const sHtml = `
            <section id="${
              this.sWrapper
            }" class="popup popup_layer popup_review">
                <header class="popup_header">
                    <h3 class="popup_header_title">이미지 상세보기</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <div class="popup_inner">
                        <div class="img_detail">
                            <div class="swiper-container" id="_reviewImageSwiper">
                                <ul id="sliderPreview"class="swiper-wrapper">
                                    ${this.getImageListHtml(aImageList)}
                                </ul>
                            </div>
                            ${
                              TMON.oApp.sPlatform === 'PW'
                                ? '<button type="button" class="btn_slide_prev" data-role="previewImageButton" data-type="prev">이전 슬라이드</button><button type="button" class="btn_slide_next" data-role="previewImageButton" data-type="next">디음 슬라이드</button>'
                                : ''
                            }
                        </div>
                    </div>
                    <div class="ft">
                        <div class="paging slide_pagination" id="_imagePreviewPager">
                            ${this.getPagerHtml(aImageList)}
                        </div>
                    </div>
                </div>
            </section>
        `;

    this.welContainer.append(sHtml);
  };

  getImageListHtml = aImageList => {
    const sHtml = `
            ${aImageList
              .map(
                imgUrl =>
                  `<li class="swipe-item swiper-slide"><img src="${imgUrl}" alt="상품 이미지"></li>`
              )
              .join('')}
        `;
    return sHtml;
  };

  getPagerHtml = aImageList => {
    let sHtml = '';
    if (this.sPagingType === 'number') {
      sHtml = `<span class="current">1</span>/<span class="total">${aImageList.length}</span>`;
    } else if (this.sPagingType === 'dot') {
      sHtml = `
                ${aImageList
                  .map(
                    (imgUrl, idx) => `
                            <button class="${
                              idx === this.realIndex ? 'on' : ''
                            }" type="button" data-img="${imgUrl}" data-index="${idx}"><span class="blind"><em>${idx +
                      1}</em>페이지</span></button>
                        `
                  )
                  .join('')}
            `;
    }
    return sHtml;
  };
}
